import React, { useState } from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { withLocalize } from 'react-localize-redux'
import { ArticleCreateEditForm } from 'containers'
import { articles } from 'redux/modules'
import { createSubUrl } from 'utils/urlConstructor'
import getTargetTranslationFields from 'utils/getTargetTranslationFields'
import { toast } from 'react-toastify'
import PropTypes from 'prop-types'
import { ARTICLES_DASHBOARD_ROUTE } from 'constants/routes'

const FIELDS_WITH_TRANSLATION = ['title', 'body']

const ArticleEditContainer = ({
  history,
  match,
  location: { fromUrl, fromPathname = 'Articles' },
  article: { translations, image_url: image, podcast, video, ...article },
  articlesCategories,
  updateArticle,
  activeLanguage: { code: activeLocale },
}) => {
  const linkBack = fromUrl || createSubUrl(match, ARTICLES_DASHBOARD_ROUTE)

  const goBack = () => history.push(linkBack)
  const [selectedType, setSelectedType] = useState('article')

  const onSubmit = (values) => {
    let data = { ...values }

    data.categories = data.categories
      .map((uuid) => {
        const matchedCategory = articlesCategories.find(
          (cat) => cat.uuid === uuid
        )

        return matchedCategory ? matchedCategory.id : null
      })
      .filter((id) => id !== null)

    if (selectedType === 'video') {
      delete data.podcast
      delete data.body

      // @tofix Fix validation using JOI if possible.
      if (!data.video) {
        toast.error('Select a video first')

        return
      }
    } else if (selectedType === 'podcast') {
      delete data.video
      delete data.body

      // @tofix Fix validation using JOI if possible.
      if (!data.podcast) {
        toast.error('Select an audio first')

        return
      }
    } else {
      delete data.video
      delete data.podcast

      // @tofix Fix validation using JOI if possible.
      if (!data.body) {
        toast.error('Please explain the article content')

        return
      }
    }

    data = { ...data, type: selectedType }

    updateArticle(match.params.articleId, data).then(goBack)
  }

  return (
    <ArticleCreateEditForm
      form="articleEdit"
      initialValues={{
        ...article,
        image,
        podcast: podcast ? podcast.full_url : null,
        video: video ? video.full_url : null,
        ...getTargetTranslationFields(
          translations,
          activeLocale,
          FIELDS_WITH_TRANSLATION
        ),
        locale: activeLocale,
      }}
      fromPath={{
        value: linkBack,
        title: fromPathname,
      }}
      onSubmit={onSubmit}
      articlesCategories={articlesCategories}
      isEditForm
      setSelectedType={setSelectedType}
    />
  )
}

ArticleEditContainer.defaultProps = {
  articlesCategories: [],
}

ArticleEditContainer.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  match: PropTypes.shape({
    params: PropTypes.objectOf(PropTypes.string).isRequired,
  }).isRequired,
  location: PropTypes.shape({
    fromUrl: PropTypes.string,
    fromPathname: PropTypes.string,
  }).isRequired,
  article: PropTypes.shape().isRequired,
  articlesCategories: PropTypes.arrayOf(
    PropTypes.shape({
      uuid: PropTypes.string.isRequired,
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    })
  ),
  updateArticle: PropTypes.func.isRequired,
  activeLanguage: PropTypes.shape().isRequired,
}

export default compose(
  connect(
    ({
      articles: {
        current: { articlesCategories, ...article },
      },
    }) => ({ article, articlesCategories }),
    {
      updateArticle: articles.updateArticle,
    }
  ),
  withLocalize
)(ArticleEditContainer)
